import { UploadOutlined } from "@ant-design/icons";
import { Alert, Avatar, Button, Col, Divider, Input, Row, Upload } from "antd";
import { collection, doc, getDoc, updateDoc } from "firebase/firestore";
import React, { useEffect } from "react";
import { db } from "../../../../../../../firebase";

const EvaluateAndTask = () => {
  const { TextArea } = Input;

  return (
    <div>
      <Alert
        message="The items on this list should be done right away. "
        type="error"
        style={{ textAlign: "center", marginBottom: "10px" }}
      />

      <Alert
        message="DO NOT DELAY"
        type="error"
        style={{ textAlign: "center", marginBottom: "10px" }}
      />
      <Alert
        message="to start these items until just before move out dates.  they must be started"
        type="error"
        style={{ textAlign: "center", marginBottom: "10px" }}
      />
      <Alert
        message="RIGHT AWAY!"
        type="error"
        style={{ textAlign: "center", marginBottom: "10px" }}
      />

      <Row justify="end">
        <Col>
          <Button>Next</Button>
        </Col>
      </Row>
      <Divider />

      <Row>
        <Col span={2}>
          <Avatar>KA</Avatar>
        </Col>
        <Col span={22}>
          <TextArea
            style={{
              height: 200,
              resize: "none",
            }}
            placeholder="Write a comment… Type @ to mention other users."
          />
        </Col>
      </Row>
      <Row justify="end" gutter={16}>
        <Col>
          <Upload>
            <Button style={{ marginTop: "10px" }}>
              <UploadOutlined />
            </Button>
          </Upload>
        </Col>
        <Col>
          <Button style={{ marginTop: "10px" }}>Send</Button>
        </Col>{" "}
      </Row>
    </div>
  );
};

export default EvaluateAndTask;
